import { render } from "./collected.vue?vue&type=template&id=5f4370e6&scoped=true"
import script from "./collected.vue?vue&type=script&lang=js"
export * from "./collected.vue?vue&type=script&lang=js"

import "./collected.vue?vue&type=style&index=0&id=5f4370e6&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4370e6"]])

export default __exports__